(function () {
    "use strict";

    angular
        .module("app")
        .directive("criticalPathCommercializationList", ["CriticalPathService", criticalPathCommercializationList]);

    function criticalPathCommercializationList(CriticalPathService) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.filterText = "";

                scope.loadData = function (patternId, prototypeSeasonalId) {
                    if (!patternId && !prototypeSeasonalId) {
                        scope.data = [];
                        return;
                    }
                    if (patternId) {
                        CriticalPathService.getCpCommercializationsForPattern(patternId).then(function (response) {
                            scope.data = response;
                            scope.showCreateButton = (scope.data.length > 0 && scope.data[0].CriticalPathName == null) || (scope.data.length == 0) ? true : false;

                            if (scope.hide) {
                                scope.showCreateButton = 0;
                            }
                        });
                    }

                    else if (prototypeSeasonalId) {
                        CriticalPathService.getCpCommercializationsForPrototype(prototypeSeasonalId).then(function (response) {
                            scope.data = response;
                            scope.showCreateButton = (scope.data.length > 0 && scope.data[0].CriticalPathName == null) || (scope.data.length == 0) ? true : false;
                            if (scope.status != 2 && scope.status != 3) {
                                scope.showCreateButton = 0;

                            }
                        });
                    }
                }

                scope.loadData(scope.patternId, scope.prototypeSeasonalId);

                scope.$watchGroup(["patternId", "prototypeSeasonalId"], function (newValues, oldValues) {
                    if (newValues[0] !== oldValues[0] || newValues[1] !== oldValues[1])
                        scope.loadData(newValues[0], newValues[1]);
                });

                scope.$watch("updateDirectives", function (newValue) {
                    if (typeof newValue === "undefined")
                        return;
                    scope.loadData(scope.patternId, scope.prototypeSeasonalId);
                });

                scope.createCP = function () {
                    CriticalPathService.CreateCriticalPathCommercialization(scope.prototypeSeasonalId).then(function (response) {
                        if (response) {
                            scope.loadData(scope.patternId, scope.prototypeSeasonalId);
                        }
                    });
                }
            },
            scope: { patternId: "=", prototypeSeasonalId: "=", showSeasons: "=", currentSeasonName: "=", updateDirectives: "=", prototype: "=", prototypeSeasonal: "=", userid: "=", hide: "=", status: "=" },
            templateUrl: templateUrl("app/components/criticalPath/commercializationList.directive.html")
        };
    }
})();
